import { render } from "./SelectBank.vue?vue&type=template&id=10a2c5e2"
import script from "./SelectBank.vue?vue&type=script&lang=js"
export * from "./SelectBank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__